import api from './api';
import { fetchPage } from './pagedParams';

const userManagementService = {
  // User CRUD
  getAllUsers: async () => {
    const response = await api.get('/admin/users');
    return response.data;
  },

  searchUsers: async (query) => {
    const response = await api.get(`/admin/users/search?query=${query}`);
    return response.data;
  },

  getUserById: async (id) => {
    const response = await api.get(`/admin/users/${id}`);
    return response.data;
  },

  getCurrentUserProfile: async () => {
    const response = await api.get('/admin/users/profile');
    return response.data;
  },

  updateCurrentUserProfile: async (profileData) => {
    const response = await api.put('/admin/users/profile', profileData);
    return response.data;
  },

  changePassword: async (passwordData) => {
    await api.post('/admin/users/change-password', passwordData);
  },

  createUser: async (userData) => {
    const response = await api.post('/admin/users', userData);
    return response.data;
  },

  updateUser: async (id, userData) => {
    const response = await api.put(`/admin/users/${id}`, userData);
    return response.data;
  },

  toggleActive: async (id) => {
    const response = await api.patch(`/admin/users/${id}/toggle-active`);
    return response.data;
  },

  deleteUser: async (id) => {
    await api.delete(`/admin/users/${id}`);
  },

  // Role assignment
  assignRole: async (userId, roleData) => {
    await api.post(`/admin/users/${userId}/assign-role`, roleData);
  },

  removeRole: async (userId) => {
    await api.delete(`/admin/users/${userId}/remove-role`);
  },

  // Permission management
  assignPermission: async (userId, permissionData) => {
    await api.post(`/admin/users/${userId}/permissions`, permissionData);
  },

  revokePermission: async (userId, permissionId) => {
    await api.delete(`/admin/users/${userId}/permissions/${permissionId}`);
  },

  getUserDirectPermissions: async (userId) => {
    const response = await api.get(`/admin/users/${userId}/permissions`);
    return response.data;
  },

  // Store access management
  assignStoreAccess: async (userId, storeAccessData) => {
    await api.post(`/admin/users/${userId}/stores`, storeAccessData);
  },

  revokeStoreAccess: async (userId, storeId) => {
    await api.delete(`/admin/users/${userId}/stores/${storeId}`);
  },

  getUserStoreAccess: async (userId) => {
    const response = await api.get(`/admin/users/${userId}/stores`);
    return response.data;
  },

  // Server-side paged list (Spring Page) for the URL-driven DataTable.
  getUsersPage: (params) => fetchPage('/admin/users/paged', params),

};

export default userManagementService;